export const state = {
  currentUser: {},
  documents: [],
  language: 'ru',
}
